module.exports = __webpack_public_path__ + "static/mh-result-a494e2ee574ae00a147807545943ddba.png";